import { render } from "./AppRouter.vue?vue&type=template&id=38d8e42e"
import script from "./AppRouter.vue?vue&type=script&lang=js"
export * from "./AppRouter.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__